import dayjs from "@onair/utils/dayjs";
import Link from "next/link";
import { memo } from "react";
interface CardPostProps {
	title?: string | React.ReactNode;
	thunmbnailUrl?: string;
	authorAvatarUrl?: string;
	authorName?: string;
	createdAt?: string;
	slug?: string;
}
const CardPost: React.FC<CardPostProps> = ({
	thunmbnailUrl,
	title,
	createdAt,
	authorAvatarUrl,
	authorName,
	slug,
}) => {
	return (
		<div className="card-post group/card-item">
			<Link href={`/post/${slug}`} className="block">
				<div className="card-post__thumbnail aspect-[9/5] mb-3 overflow-hidden bg-slate-100">
					<img
						src={thunmbnailUrl}
						loading="lazy"
						className="w-full h-full object-cover"
					/>
				</div>
				<div className="card-post__content">
					<div className="flex items-center justify-between mb-3">
						{authorAvatarUrl ? (
							<div className="flex items-center">
								<img src={authorAvatarUrl} className="w-6 h-6 rounded-full" />
								<span className="ml-2 text-sm text-gray-700">{authorName}</span>
							</div>
						) : null}
						{createdAt ? (
							<div className="text-gray-600">
								<time className="text-gray-600 text-sm" dateTime={createdAt}>
									{dayjs(createdAt).format("DD [tháng] MM, YYYY")}
								</time>
							</div>
						) : null}
					</div>
					{title && typeof title === "string" && (
						<h3 className="text-lg font-semibold line-clamp-2 group-hover/card-item:text-blue-700">
							{title}
						</h3>
					)}
					{title && typeof title !== "string" && title}
				</div>
			</Link>
		</div>
	);
};
export default memo(CardPost);
